import FormControls from 'component/FormControls';
import Page from 'component/Page';
// import { useState, useMemo } from 'react';
// import { useSelector } from 'react-redux';
// import { selectCurrentUser } from 'redux/user/user.selector';
// import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { Button, Form, Row } from 'react-bootstrap';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
    focusElement,
    getFormData,
    showConfirm,
    showToast,
    nNU,
    // serialValidate,
    // couponCodeValidate,
    formatDate,
} from 'util/utils';

// const modelTable = [
//     'DRDPM62W',
//     // "DJDPS72W",
//     // "DJP422W",
// ];

const ServiceCodeActivate = ({ data = { id: null, valid: true }, onUpdated }) => {
    //-------------------------------HOOKS-------------------------------------------------------------
    // const currentUser = useSelector(selectCurrentUser);
    //const [showPassword, setShowPassword] = useState(false);
    // const isAdmin = useMemo(
    //     () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    //     [ currentUser.accountRole ]
    // );

    //------------------------FUNCTIONS----------------------------------------------------------
    const onSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let formData = getFormData(e.target, {
            rawCol: {
                code1: true,
                code2: true,
                code3: true,
                code4: true,
                code5: true,

            },
        });

        if (!formData?.code1) {
					showToast(string.APP_USER_ADD_SC_INPUT01_EMPTY_ERROR);
					focusElement('#code1');
					return;
        } else if (formData?.code1.length < 6) {
					showToast(string.APP_USER_ADD_SC_INPUT01_LENGTH_ERROR);
					focusElement('#code1');
					return;
				}
        if (!formData?.code2) {
					showToast(string.APP_USER_ADD_SC_INPUT02_EMPTY_ERROR);
					focusElement('#code2');
					return;
				} else if (formData?.code2.length < 4) {
					showToast(string.APP_USER_ADD_SC_INPUT02_LENGTH_ERROR);
					focusElement('#code2');
					return;
				}
        if (!formData?.code3) {
					showToast(string.APP_USER_ADD_SC_INPUT03_EMPTY_ERROR);
					focusElement('#code3');
					return;
				} else if (formData?.code3.length < 4) {
					showToast(string.APP_USER_ADD_SC_INPUT03_LENGTH_ERROR);
					focusElement('#code3');
					return;
				}
        if (!formData?.code4) {
					showToast(string.APP_USER_ADD_SC_INPUT04_EMPTY_ERROR);
					focusElement('#code4');
					return;
				} else if (formData?.code4.length < 4) {
					showToast(string.APP_USER_ADD_SC_INPUT04_LENGTH_ERROR);
					focusElement('#code4');
					return;
				}
        if (!formData?.code5) {
					showToast(string.APP_USER_ADD_SC_INPUT05_EMPTY_ERROR);
					focusElement('#code5');
					return;
				} else if (formData?.code5.length < 4) {
					showToast(string.APP_USER_ADD_SC_INPUT05_LENGTH_ERROR);
					focusElement('#code5');
					return;
				}

        const formattedCode = `${formData?.code1.toUpperCase()}${formData?.code2.toUpperCase()}${formData?.code3.toUpperCase()}${formData?.code4.toUpperCase()}${formData?.code5.toUpperCase()}`;
				let Data = {
            code: formattedCode,
        };
        showConfirm({
            body: string.APP_USER_ADD_SC_ACTIVATE_CONFIRM,
            defaultAction: () => {
                sendPost({
                    url: Urls.servicecode.active,
                    body: Data,
                }).then((res) => {
									// showToast(string.APP_USER_ADD_SC_ACTIVATE_SUCCESS, 'success');
									// onUpdated(res);
									const { status } = res;
									const result = !!nNU(res?.result) ? res?.result : '';
									const errorCode = !!nNU(res?.errorCode) ? res?.errorCode : null;
									if (status === 'SUCCESS') {
										if (errorCode === null) {
											showToast(string.APP_USER_ADD_SC_ACTIVATE_SUCCESS,'success');
										} else {
											if (!!nNU(result?.remaining) && result?.remaining > 0) {
												showToast(
													`${
														string.APP_USER_SC_APPLY_ERROR
													}\n残り入力回数：${
														!!nNU(result?.remaining) ? result?.remaining : '0'
													}回です。`,
													'warning'
												);
											} else {
												showToast(
													`${string.APP_USER_SC_REPEAT_ERROR}\n${
														!!nNU(result?.tryAgainAt)
															? `${formatDate(
																	result.tryAgainAt,
																	'YYYY年MM月DD日 HH時以降'
																)}${string.APP_USER_SC_REAPPLY}`
															: ''
													}`,
													'error'
												);
											}
										}
									}
									onUpdated(res);
								}).catch((e) => {

								});
            },
        });
    };
    const onCode1Changed = (e) => {
        // console.log('onCode1Changed' + e.target.value);
        const code = e.target.value;
        if (code.length > 5) {
            focusElement('#code2');
        }
    };
    const onCode2Changed = (e) => {
        // console.log('onCode1Changed' + e.target.value);
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#code3');
        }
    };
    const onCode3Changed = (e) => {
        // console.log('onCode2Changed');
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#code4');
        }
    };
    const onCode4Changed = (e) => {
        // console.log('onCode3Changed');
        const code = e.target.value;
        if (code.length > 3) {
            focusElement('#code5');
        }
    };

    //------------------------------------RETURN---------------------------------------------------------
    return (
        <>
            <Page
                title={`${string.APP_USER_ADD_SC_TITLE}`}
                body={
                    <>
                        <Form onSubmit={onSubmit}>
                            {/* <Card.Title>{string.APP_ACCOUNT_SETTING}</Card.Title> */}
                            <FormControls
                                data={data}
                                controls={[
                                    {
                                        id: 'code1',
                                        title: string.APP_USER_ADD_SC_INPUT01,
                                        maxlength: '6',
                                        onChange: onCode1Changed,
                                    },
                                    {
                                        id: 'code2',
                                        title: string.APP_USER_ADD_SC_INPUT02,
                                        maxlength: '4',
                                        onChange: onCode2Changed,

                                    },
                                    {
                                        id: 'code3',
                                        title: string.APP_USER_ADD_SC_INPUT03,
                                        maxlength: '4',
                                        onChange: onCode3Changed,
                                    },
                                    {
                                        id: 'code4',
                                        title: string.APP_USER_ADD_SC_INPUT04,
                                        maxlength: '4',
                                        onChange: onCode4Changed,
                                    },
                                    {
                                        id: 'code5',
                                        title: string.APP_USER_ADD_SC_INPUT05,
                                        maxlength: '4',
                                        // onChange: onCode4Changed,
                                    },
                                ]}
                                footer={<></>}
                            />
                            {/* <Card.Title>{string.APP_PASSWORD_CHANGE}</Card.Title> */}
                            <Row className="form-button-row" id="submit">
                                <Button type="submit">
                                    {string.POC_ACCOUNT_COUPON_SUBMIT}
                                </Button>
                            </Row>
                        </Form>
                    </>
                }
            />
        </>
    );
};

export default ServiceCodeActivate;
